export default {
  sort: '-publishedUpdatedDate',
  filter: '',
  search: '',
  contentCategories: [],
  tags: [],
  type: ''
};